let BASE_URL = "";

const apiEnvUrl =
  process.env.REACT_APP_API_URL?.replace(/\/$/, "") || null;

if (apiEnvUrl) {
  BASE_URL = apiEnvUrl.endsWith("/api") ? apiEnvUrl : `${apiEnvUrl}/api`;
} else if (process.env.NODE_ENV === "development") {
  BASE_URL = "http://localhost:3000/api";
} else if (process.env.NODE_ENV === "production") {
  BASE_URL = "https://app.relinqsales.com.br/api";
}

const WHATSAPP = {
  BASE_URL: BASE_URL,
  API_KEY: null,
  CONNECT: (tenantId) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/connect`,
  QR: (tenantId) => `/whatsapp/${encodeURIComponent(tenantId)}/qr`,
  // Sair da tela do QR sem ler: o número novo (que nunca conectou) não fica
  // registrado e o próximo QR é gerado do zero.
  CONNECT_CANCEL: (tenantId) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/connect/cancel`,
  STATUS: (tenantId) => `/whatsapp/${encodeURIComponent(tenantId)}/session`,
  DISCONNECT: (tenantId) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/disconnect`,
  REMOVE_SESSION: (tenantId) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/session`,
  // Gestão dos números no modo individual (Integrações › WhatsApp): lista de
  // todos os números da empresa + vendedores, trocar o vendedor (PATCH na
  // sessão), excluir (DELETE na sessão) e reconexão rápida sem novo QR.
  SESSIONS: () => `/whatsapp/sessions`,
  SESSION_UPDATE: (tenantId) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/session`,
  RECONNECT: (tenantId) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/reconnect`,
  LIST_MESSAGES: (tenantId) => `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/messages`,
  LIST_CONVERSATIONS: (tenantId) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/conversations`,
  UNREAD_ASSIGNED_COUNT: (tenantId) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/conversations/unread-count`,
  CONVERSATION_EVENTS: (tenantId, contact) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/events`,
  CONVERSATION_DETAILS: (tenantId, contact) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}`,
  SESSION_INFO: (tenantId) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/session`,
  TEMPLATES: (tenantId) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/templates`,
  TEMPLATE: (tenantId, id) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/templates/${encodeURIComponent(id)}`,
  TEMPLATE_VARIABLES: (tenantId) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/templates/variables`,
  TEMPLATE_MEDIA: (tenantId) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/templates/media`,
  META_EMBEDDED_SIGNUP_CONFIG: (tenantId) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/meta/embedded-signup/config`,
  META_EMBEDDED_SIGNUP_EXCHANGE: (tenantId) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/meta/embedded-signup/exchange`,
  IMPROVE_MESSAGE: (tenantId) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/ai/improve`,
  AI_AGENT_CONFIG: (tenantId) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/ai/agent-config`,
  // Fluxos de conversa (chatbot). Escopo por empresa via JWT — não levam
  // tenantId no caminho, diferente dos demais endpoints de WhatsApp.
  FLOWS: () => `${BASE_URL}/whatsapp-flows`,
  FLOW: (flowId) => `${BASE_URL}/whatsapp-flows/${encodeURIComponent(flowId)}`,
  FLOW_CONTACT_VARIABLES: (contact) =>
    `${BASE_URL}/whatsapp-flows/contact-variables/${encodeURIComponent(contact)}`,
  FLOW_MEDIA: () => `${BASE_URL}/whatsapp-flows/media`,
  FLOW_VALIDATE: () => `${BASE_URL}/whatsapp-flows/validate`,
  FLOW_SESSIONS: () => `${BASE_URL}/whatsapp-flows/sessions`,
  FLOW_SESSION_LOGS: (flowSessionId) =>
    `${BASE_URL}/whatsapp-flows/sessions/${encodeURIComponent(flowSessionId)}/logs`,
  // Catálogo de etiquetas da empresa (para o filtro da caixa de entrada).
  TAGS: (tenantId) => `/whatsapp/${encodeURIComponent(tenantId)}/tags`,
  // Apagar para todos (revoga no WhatsApp do contato).
  MESSAGE: (tenantId, messageId) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/messages/${encodeURIComponent(messageId)}`,
  CONVERSATION_PRESENCE: (tenantId, contact) =>
    `${BASE_URL}/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/presence`,
  // Organização da caixa de entrada (estado global no CRM). Caminhos relativos:
  // consumidos pelo apiClient, que já prefixa o baseURL.
  CONVERSATION_ARCHIVE: (tenantId, contact) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/archive`,
  CONVERSATION_PIN: (tenantId, contact) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/pin`,
  CONVERSATION_MUTE: (tenantId, contact) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/mute`,
  CONVERSATION_RESOLVE: (tenantId, contact) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/resolve`,
  // Notas internas da conversa.
  CONVERSATION_NOTES: (tenantId, contact) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/notes`,
  CONVERSATION_NOTE: (tenantId, contact, noteId) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/notes/${encodeURIComponent(noteId)}`,
  // Mensagens agendadas.
  CONVERSATION_SCHEDULE: (tenantId, contact) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/schedule`,
  CONVERSATION_SCHEDULED: (tenantId, contact) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/scheduled`,
  CONVERSATION_SCHEDULED_CANCEL: (tenantId, contact, scheduleId) =>
    `/whatsapp/${encodeURIComponent(tenantId)}/conversations/${encodeURIComponent(contact)}/scheduled/${encodeURIComponent(scheduleId)}`,
};

const LOGIN = {
  POST_LOGIN: BASE_URL + "/acessar",
};

const PASSWORD_RECOVERY = {
  FORGOT: "/forgot-password",
  RESET: "/reset-password",
};

const LOAN = {
  GET_LOAN_BY_IDENTIFIER: "/form",
  PUBLIC_FORM: (slug) => `/form/${slug}`,
  PUBLIC_CARD_FORM: (cardId) => `/card-form/${cardId}`,
  // Script do formulário incorporado no site do cliente (utils/formEmbed.js).
  FORM_EMBED_SCRIPT: "/embed/forms.js",
  GET_DOCUMENT_TYPES: "/document-types",
  GET_SEGMENTS: "/segments",
  UPLOAD_PARTIAL_FORM: "/form/upload-partial",
  UPLOAD_LOAN_DOCUMENT: "/form/upload-document",
  GET_ALL: "/loans",
  INVALIDATE_DOCUMENT: "/document/invalidate",
  GET_DASHBOARD_DATA: "/dashboard/data",
  GET_DASHBOARD_DAILY_DATA: "/dashboard/daily",
  CREATE_NEW: "/simulation-admin",
  PREPARE_SIGN: "/prepare-sign",
};

const API = {
  GET_TOKEN: "/get-api-rest-token",
};

const BLACKLIST = {
  GET_ALL: "/blacklists",
  GET: "/blacklist",
  SEARCH: "/blacklist/search",
};

const CATEGORIES = {
  GET_ALL: "/categories",
  CREATE: "/categories",
  UPDATE: (id) => `/categories/${id}`,
  DELETE: (id) => `/categories/${id}`,
};

const COMPANY = {
  GET_ACTIVE: "/company/active",
  GET_PERMISSION_QUERIES: "/company/permission/queries",
  GET_DOCS: "/company/docs",
  GET_EXTERNAL_INFO: "/company/external-info",
  UPDATE_PREFERENCES: "/company/preferences",
};

const USERS = {
  GET_USERS: "/users", // GET ?page&itemsPerPage&includeInactive&roleId (filtra por papel)
  GET_ROLE_OPTIONS: "/users/roles", // GET papéis da empresa para o filtro (settings.user.manage)
  GET_USER: "/user",
  GET_USER_CURRENT: "/user-current",
  GET_USER_QUERY_PERMISSIONS: "/user-query/permission",
  GET_USER_BY_EMAIL: "/user/email",
  UPDATE_PREFERENCES: "/user/preferences",
  UPLOAD_AVATAR: "/user/avatar",
};

const ADMIN = {
  GET_CUSTOMERS: "/admin/customers",
  GET_REPRESENTATIVES: "/admin/representatives",
  GET_COMPANY_QUERIES: "/admin/company/queries",
  GET_QUERIES: "/admin/queries",
  GET_USERS: "/admin/users",
  GET_PROVIDERS: "/admin/providers",
  GET_PROVIDERS_ALL: "/admin/providers-all",
  NEW_CUSTOMER: "/customer/new",
  NEW_REPRESENTATIVE: "/admin/representative/new",
  GET_COMPANY_BY_INFO: "/admin/company/info",
  GET_COMPANY: "/admin/company",
  GET_COMPANY_DETAIL: (id) => `/admin/company/${id}/detail`,
  UPLOAD_COMPANY_LOGO: (id) => `/admin/company/${id}/logo`,
  GET_COMPANY_QUERIES_HISTORY: "/admin/queries/company",
  GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED: "/admin/queries/company/simplified",
  GET_PAYMENTS: "/admin/payments",
  GET_QUERY: "/admin/query",
  GET_TABLE_QUERIES: "/admin/table/queries",
  GET_TABLES: "/admin/tables",
  GET_TABLE: "/admin/table",
  GET_SURVEY_REPORT: "/admin/survey/company",
  GET_CUSTOMIZED_QUERY: "/admin/customized-query",
  GET_HISTORY_INVOICES: "/admin/invoices/history",
};

const FILIAL = {
  LIST: "/filiais",
  CREATE: "/filiais",
  OFFICE_USERS: "/filiais/escritorio-usuarios",
  REMOVE: (id) => `/filiais/${id}`,
  MY_COMPANIES: "/minhas-empresas",
  MY_COMPANIES_ALERTS: "/minhas-empresas/alertas",
  SWITCH: (id) => `/trocar-empresa/${id}`,
  GET_USER_ACCESS: (userId) => `/filiais/acesso/${userId}`,
  GET_FILIAL_MEMBERS: (filialId) => `/filiais/membros/${filialId}`,
  GRANT_ACCESS: (userId, filialId) => `/filiais/acesso/${userId}/${filialId}`,
  REVOKE_ACCESS: (userId, filialId) => `/filiais/acesso/${userId}/${filialId}`,
};

const CHARGES = {
  SEND: "/charge/send",
  GET_ALL: "/charges",
  GET: "/charge",
  GET_TYPES: "/charges/types",
};

const DASHBOARD = {
  GET_ALL: `/dashboard`,
  GET_MANAGER: `/dashboard/manager`,
  GET_SUMMARY: `/dashboard/summary`,
  GET_PIPELINE: `/dashboard/pipeline`,
  GET_FORECAST: `/dashboard/forecast`,
  GET_VELOCITY: `/dashboard/velocity`,
  GET_SOURCES: `/dashboard/sources`,
  GET_LEADERBOARD: `/dashboard/leaderboard`,
  GET_FOLLOW_UPS: `/dashboard/follow-ups`,
  GET_RISKS: `/dashboard/risks`,
  GET_USER_OVERVIEW: `/dashboard/user/overview`,
};

const QUERIES = {
  GET_LOCALIZA_CNPJ: "/query/localiza-cnpj",
  GET_LAST_QUERIES: "/query/last",
  GET_LAST_7_DAYS_COUNT_QUERIES: "/query/total/last/7",
  GET_QUERIES_TOTAL: "/query/total",
  GET_QUERIES_LIST: "/queries",
  UPLOAD_PDF: "/query/upload/pdf",
  DOWNLOAD_PDF: "/query/download/pdf",
  GENERATE_PDF: "/generate/pdf",
  GET_DASHBOARD_INFOS: "/query/dashboard",
  GET_DASHBOARD_INFOS_REPRESENTATIVE: "/query/dashboard/representative",
  GET_DASHBOARD_INFOS_POWER_USER: "/query/dashboard/power-user",
  GET_V1_QUERY: "/v1",
  GET_V2_QUERY: "/v2",
  GET_USER_QUERY: "/query/user-query",
};

const QUERIES_VEICULAR = {
  GET_COMPLETA_VEICULAR: "/query/completa-veicular",
  GET_LEILAO_POSITIVO: "/query/leilao-positivo",
  GET_VEICULAR: "/query/veicular",
  GET_PRECIFICADOR: "/query/veicular/precificador",
  GET_BIN_NACIONAL: "/query/veicular/bin-nacional",
};

const INTEGRATIONS = {
  OPEN_CNPJ_COMPANIES: "/integrations/opencnpj/empresas",
  GOOGLE_CALENDAR_URL: "/integrations/google-calendar/url",
  GOOGLE_CALENDAR_TOKEN: "/integrations/google-calendar/token",
  MICROSOFT_CALENDAR_URL: "/integrations/microsoft-calendar/url",
  MICROSOFT_CALENDAR_TOKEN: "/integrations/microsoft-calendar/token",
  EMAIL_CONFIG: "/integrations/email/config",
  OUTLOOK_EMAIL_URL: "/integrations/outlook-email/url",
  OUTLOOK_EMAIL_TOKEN: "/integrations/outlook-email/token",
  OUTLOOK_EMAIL_TEST: "/integrations/outlook-email/test",
  GMAIL_EMAIL_URL: "/integrations/gmail-email/url",
  GMAIL_EMAIL_TOKEN: "/integrations/gmail-email/token",
  GMAIL_EMAIL_TEST: "/integrations/gmail-email/test",
  META_ADS_CONFIG: "/integrations/meta-ads/config",
  LIST_TOKENS: "/integrations/tokens",
  COMPANY_ACCESS: "/integrations/company-access",
  COMPANY_ACCESS_CURRENT: "/integrations/company-access/current",
  OPENAI_STATUS: "/integrations/openai/status",
  AI_CONFIG: "/integrations/ai/config",
  AI_TEST: "/integrations/ai/test",
  DELETE_TOKEN: (type) => `/integrations/tokens/${type}`,
  GOOGLE_CALENDAR_EVENTS: "/integrations/google-calendar/events",
  EMAIL_TEST: "/integrations/email/test",
};

const EMAILS = {
  SENDER_STATUS: "/emails/sender-status",
  BY_CARD: (cardId) => `/emails/card/${cardId}`,
  LIST: "/emails",
  SYNC: "/emails/sync",
  ATTACHMENT_URL: "/emails/attachments/signed-url",
  // Sobe anexos sem enviar e-mail — usado pela ação de e-mail da automação,
  // que precisa guardar o arquivo na hora de montar a automação.
  UPLOAD_ATTACHMENTS: "/emails/attachments",
  RETRY: (id) => `/emails/${id}/retry`,
  MARK_READ: (id) => `/emails/${id}/read`,
};

const EMAIL_TEMPLATES = {
  LIST: "/email-templates",
  CREATE: "/email-templates",
  PREVIEW: "/email-templates/preview",
  UPDATE: (id) => `/email-templates/${id}`,
  PREVIEW_BY_ID: (id) => `/email-templates/${id}/preview`,
  DELETE: (id) => `/email-templates/${id}`,
};

const EMAIL_SIGNATURES = {
  GET: "/email-signatures",
  SAVE_MINE: "/email-signatures/me",
  DELETE_MINE: "/email-signatures/me",
  SAVE_COMPANY: "/email-signatures/company",
  DELETE_COMPANY: "/email-signatures/company",
  UPLOAD_IMAGE: "/email-signatures/image",
};

const VOIP = {
  CALL: "/voip/call",
  CLIENT_TOKEN: "/voip/client-token",
  TWILIO_CLIENT_TOKEN: "/voip/twilio-client-token",
  // Registro de ligações (tela "VoIP"): lista com filtros e resumo, e o
  // link assinado da gravação de uma ligação.
  CALLS: "/voip/calls",
  CALL_RECORDING: (id) => `/voip/calls/${id}/recording`,
  // Comentários da tela VoIP (só administrador).
  CALL_COMMENTS: (id) => `/voip/calls/${id}/comments`,
  // Cards do contato dono do número (o discador decide onde criar a tarefa).
  CONTACT_CARDS: "/voip/contact-cards",
};

const AUDITS = {
  GET_AUDITS: "/audits",
};

const AVATAR = {
  UPLOAD: "/avatar/upload",
};

const PAYMENTS = {
  CREATE: "/payment/create",
  CREATE_PAYMENT_ADMIN: "/admin/payment/create",
  GET_ALL: "/invoices",
  ADD_CREDIT: "/payment/confirm",
  ADD_CREDIT_MANUALLY: "/payment/manually",
};

const REPORTS = {
  GET_COMPANY_QUERIES_HISTORY: "/report/queries/company",
  GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED: "/report/queries/company/simplified",
  OVERVIEW: "/reports/overview",
};

const SURVEYS = {
  GET_SURVEY: "/survey",
  GET_ALL_SURVEY: "/surveys",
  GET_TAGS: "/survey/tags",
  GET_SURVEY_VEHICLE: "/survey/vehicle",
  GET_SURVEY_CHECKLIST: "/survey/checklist",
  GET_CHECKLIST: "/survey/questions",
  UPLOAD_IMAGE: "/survey/image/upload",
  GET_SURVEY_IMAGES: "/survey/images",
  GET_CONFIG: "/survey/configs",
  FINISH: "/survey/finish",
  GET_REPORT: "/survey/report",
  DELETE_IMAGE_SURVEY: "/survey/image/upload",
};

const CRM = {
  FUNNELS: "/crm/funnels",
  FUNNEL_DETAILS: "/crm/funnel",
  CREATE_FUNNEL: "/crm/funnels",
  UPDATE_FUNNEL: "/crm/funnels", // + /:funnelId
  DELETE_FUNNEL: "/crm/funnels", // + /:funnelId

  CREATE_STAGE: "/crm/stages",
  UPDATE_STAGE: "/crm/stages", // + /:stageId
  DELETE_STAGE: "/crm/stages", // + /:stageId
  STAGE_CARDS: (stageId) => `/crm/stages/${stageId}/cards`,
  BOARD_CARDS: (funnelId) => `/crm/funnels/${funnelId}/board-cards`,
  // Cards com venda pendente do funil, agrupados por etapa de ganho.
  FUNNEL_PENDING_SALES: (funnelId) => `/crm/funnels/${funnelId}/pending-sales`,

  FUNNEL_PUBLIC_FORM: (funnelId) => `/crm/funnels/${funnelId}/public-form`,
  FUNNEL_PUBLIC_FORM_ITEM: (funnelId, formId) =>
    `/crm/funnels/${funnelId}/public-form/${formId}`,
  CARD_PUBLIC_FORM_TEMPLATES: (funnelId) =>
    `/crm/funnels/${funnelId}/card-public-forms`,
  CARD_PUBLIC_FORM_TEMPLATE: (funnelId, templateId) =>
    `/crm/funnels/${funnelId}/card-public-forms/${templateId}`,
  PUBLIC_FORMS: (funnelId) =>
    `/crm/public-forms${
      funnelId ? `?funnelId=${encodeURIComponent(funnelId)}` : ""
    }`,

  // ⭐️ NOVOS ENDPOINTS
  STAGE_REQUIRED_FIELDS: "/crm/stages", // + /:stageId/required-fields
  AUTOMATIONS_LIST: (funnelId) => `/crm/funnels/${funnelId}/automations`,
  AUTOMATIONS_CREATE: (funnelId) => `/crm/funnels/${funnelId}/automations`,
  UPDATE_AUTOMATION: (automationId) => `/crm/automations/${automationId}`,
  DELETE_AUTOMATION: (automationId) => `/crm/automations/${automationId}`,
  AUTOMATIONS_LOGS: (automationId) => `/crm/automations/${automationId}/logs`,
  AUTOMATIONS_RECENT_LOGS: (funnelId) =>
    `/crm/funnels/${funnelId}/automations/recent-logs`,

  CREATE_CARD: "/crm/card",
  GET_CARD: "/crm/card",
  UPDATE_CARD: "/crm/card", // + /:cardId
  REORDER_STAGE_CARDS: (stageId) => `/crm/stages/${stageId}/cards/reorder`,
  DELETE_CARD: "/crm/card", // + /:cardId
  CARD_PUBLIC_FORM: (cardId) => `/crm/card/${cardId}/public-form`,
  CARD_AI_BRIEFING: (cardId) => `/crm/card/${cardId}/ai-briefing`,
  // Vendas computadas do card. GET lista (inclui canceladas) + valor sugerido;
  // POST computa; PATCH edita; cancelar e ignorar a pendência são POSTs.
  CARD_SALES: (cardId) => `/crm/card/${cardId}/sales`,
  CARD_SALE: (cardId, saleId) => `/crm/card/${cardId}/sales/${saleId}`,
  CARD_SALE_CANCEL: (cardId, saleId) =>
    `/crm/card/${cardId}/sales/${saleId}/cancel`,
  CARD_SALES_DISMISS_PENDING: (cardId) =>
    `/crm/card/${cardId}/sales/dismiss-pending`,
  // Prévia dos gatilhos agendados do card (não executa nada).
  CARD_SCHEDULED_AUTOMATIONS: (cardId) =>
    `/crm/card/${cardId}/scheduled-automations`,

  ADD_CARD_HISTORY: "/crm/card", // + /:cardId/history
  GET_CARD_HISTORY: "/crm/card", // + /:cardId/history
  CREATE_TASK: "/crm/card", // + /:cardId/tasks
  LIST_TASKS: "/crm/card", // + /:cardId/tasks
  LIST_TASKS_FOR_CARDS: "/crm/cards/tasks",
  UPDATE_TASK: "/crm/task", // + /:taskId
  COMPLETE_TASK: "/crm/task", // + /:taskId/complete
  CANCEL_TASK: "/crm/task", // + /:taskId/cancel
  DELETE_TASK: "/crm/task", // + /:taskId
  POSTPONE_TASK: "/crm/tasks", // + /:taskId/postpone
  TODAY_TASKS: "/crm/tasks/today",
  DONE_TASKS: "/crm/tasks/done",
  TASK_RATINGS: (taskId) => `/crm/task/${taskId}/ratings`,
  TASK_FEEDBACKS: (taskId) => `/crm/task/${taskId}/feedbacks`,
  TASK_TIMELINE: (taskId) => `/crm/task/${taskId}/timeline`,

  TASK_ATTACHMENT_URL: (cardId, taskId, id) =>
    `/cards/${cardId}/tasks/${taskId}/attachments/${id}`,
  TASK_ATTACHMENT_SIGNED_URL: (cardId, taskId, id) =>
    `/cards/${cardId}/tasks/${taskId}/attachments/${id}/url`,
  TASK_ATTACHMENT_CAPTION_VIDEO: (cardId, taskId, id) =>
    `/cards/${cardId}/tasks/${taskId}/attachments/${id}/caption-video`,
  TASK_ATTACHMENT_CONVERSATION_SUMMARY: (cardId, taskId, id) =>
    `/cards/${cardId}/tasks/${taskId}/attachments/${id}/conversation-summary`,

  CARD_ATTACHMENTS: (cardId) => `/crm/card/${cardId}/attachments`,
  CARD_NOTE_FILE: (cardId) => `/crm/card/${cardId}/note-files`,
  CARD_ATTACHMENT_URL: (cardId, id) => `/cards/${cardId}/attachments/${id}`,
  CARD_ATTACHMENT_SIGNED_URL: (cardId, id) =>
    `/cards/${cardId}/attachments/${id}/url`,
  CARD_CUSTOM_FIELD_ATTACHMENT_SIGNED_URL: (cardId) =>
    `/crm/card/${cardId}/custom-fields/attachments/url`,
  CARD_ATTACHMENT_DELETE: (cardId, id) =>
    `/crm/card/${cardId}/attachments/${id}`,

  NOTIFICATION_MENTIONS: "/notifications/mentions",
};

const BUDGETS = {
  TEMPLATES: "/budgets/templates",
  CATALOG: "/budgets/catalog",
  PRESETS: "/budgets/presets",
  CLIENTS: "/budgets/clients",
  LIST: "/budgets",
  USAGE: "/budgets/usage",
  GET: (id) => `/budgets/${id}`,
  CREATE: "/budgets",
  UPDATE: (id) => `/budgets/${id}`,
  UPLOAD_PDF: (id) => `/budgets/${id}/pdf`,
};

const PRODUCTS = {
  LIST: "/products",
  GET: (id) => `/products/${id}`,
  CREATE: "/products",
  IMPORT: "/products/import",
  IMPORT_JOB_STATUS: (jobId) => `/products/import/jobs/${jobId}`,
  UPDATE: (id) => `/products/${id}`,
  DELETE: (id) => `/products/${id}`,
};

// Unidades de medida por empresa (Un, Hora, KM, m²…). O valor gravado em
// `unit` de produto/item é a `key` da unidade.
const PRODUCT_UNITS = {
  LIST: "/product-units", // GET ?includeInactive=true
  CREATE: "/product-units", // POST { label }
  UPDATE: (id) => `/product-units/${id}`, // PUT { label?, isActive?, order? }
  DELETE: (id) => `/product-units/${id}`, // DELETE (em uso: só desativa)
  REORDER: "/product-units/reorder", // PUT { ids: [] }
  RESOLVE: "/product-units/resolve", // POST { texts: [] } — prévia da importação
};

const TAGS = {
  // Lista/pesquisa paginada: ?q=&limit=&offset=&orderBy=&order=
  LIST: (companyId) => `/companies/${companyId}/tags`,

  // Obter uma tag específica
  GET: (companyId, tagId) => `/companies/${companyId}/tags/${tagId}`,

  // Criar tag: { name, color }
  CREATE: (companyId) => `/companies/${companyId}/tags`,

  // Atualizar tag: { name?, color? }
  UPDATE: (companyId, tagId) => `/companies/${companyId}/tags/${tagId}`,

  // Remover tag
  DELETE: (companyId, tagId) => `/companies/${companyId}/tags/${tagId}`,

  // Upsert em massa: [{ name, color }, ...]
  BULK_UPSERT: (companyId) => `/companies/${companyId}/tags/bulk-upsert`,

  // Reordenar (arrastar e soltar): PUT { ids: [tagId, ...] } na nova ordem
  REORDER: (companyId) => `/companies/${companyId}/tags/reorder`,
};

const TEAMS = {
  // CRUD
  LIST: "/teams", // GET ?q=&status=&page=&perPage=
  CREATE: "/teams", // POST { name, description?, status?, members? }
  GET: (id) => `/teams/${id}`, // GET
  UPDATE: (id) => `/teams/${id}`, // PUT { name?, description?, status? }
  DELETE: (id) => `/teams/${id}`, // DELETE

  // membros
  LIST_USERS: (id) => `/teams/${id}/users`, // GET
  ADD_USERS: (id) => `/teams/${id}/users/add`, // POST { members: [{userId, role?}] }
  REMOVE_USERS: (id) => `/teams/${id}/users/remove`, // POST { userIds: [1,2,3] }
  SET_USERS: (id) => `/teams/${id}/users/set`, // PUT { members: [{userId, role}] }

  // funis do time
  LIST_FUNNELS: (id) => `/teams/${id}/funnels`, // GET
  COUNT_FUNNELS: (id) => `/teams/${id}/funnels/count`, // GET

  // meus times
  MY_TEAMS: "/teams/mine", // GET (usa req.user.id ou ?userId=)
};

// Histórico de planilhas importadas (aviso de arquivo repetido).
const IMPORT_FILES = {
  CHECK: "/import-files/check", // GET ?kind=leads|products&hash=<sha256>
  REGISTER: "/import-files", // POST { kind, hash, fileName?, totalRows? }
};

const LEADS = {
  // CRUD/listagem
  LIST: "/leads", // GET ?page=&itemsPerPage=&search=&leadType=&ownerId=&tagId=&leadStageId=&companyId=&createdFrom=&createdTo=&lastContactFrom=&lastContactTo=&nextActionWindow=
  SEARCH: "/leads/search", // GET ?search=&itemsPerPage=&companyId=
  CREATE: "/leads", // POST
  GET: (id) => `/leads/${id}`, // GET
  DUPLICATE_PREVIEW: (id) => `/leads/${id}/duplicate-preview`, // GET -> { lead, cards, hiddenCardsCount } (aviso de contato repetido)
  UPDATE: (id) => `/leads/${id}`, // PATCH
  DELETE: (id) => `/leads/${id}`, // DELETE

  IMPORT: "/leads/import", // POST multipart/form-data
  CONTACTS_VISIT: "/leads/contacts-visit", // POST -> { previousVisitAt, visitedAt }
  IMPORT_JOB_STATUS: (jobId) => `/leads/import/jobs/${jobId}`,

  // utilidades
  BY_EMAIL: "/leads/by-email", // GET ?email=&companyId=

  // ações
  ASSIGN_OWNER: (id) => `/leads/${id}/assign-owner`, // PATCH { ownerId }
  NEXT_ACTION: (id) => `/leads/${id}/next-action`, // PATCH { nextAction, nextActionAt, notesAppend }
  CONVERT: (id) => `/leads/${id}/convert`, // PATCH { cardId }
  TAG: (id) => `/leads/${id}/tag`, // PATCH { tagId }
  CONSENT: (id) => `/leads/${id}/consent`, // PATCH { consentMarketing: boolean }
  RATING: (id) => `/leads/${id}/rating`, // POST { cardId?, funnelId?, taskId?, taskType?, stageId?, rating, notes? }
  HISTORY: (id) => `/leads/${id}/history`, // GET
  FEEDBACK: (id) => `/leads/${id}/feedback`, // POST (gera feedback IA e salva no lead)

  // métricas
  CONTACTS: {
    LIST: (leadId) => `/leads/${leadId}/contacts`, // GET ?onlyActive=true|false
    ADD: (leadId) => `/leads/${leadId}/contacts`, // POST { type, value, label?, isPrimary?, status? }
    ADD_BATCH: (leadId) => `/leads/${leadId}/contacts/batch`, // POST [{...},...]
    UPDATE: (leadId, contactId) => `/leads/${leadId}/contacts/${contactId}`, // PATCH {...}
    SET_PRIMARY: (leadId, contactId) =>
      `/leads/${leadId}/contacts/${contactId}/primary`, // PATCH
    SET_FAVORITE: (leadId, contactId) =>
      `/leads/${leadId}/contacts/${contactId}/favorite`, // PATCH { favorite: boolean }
    DELETE: (leadId, contactId) => `/leads/${leadId}/contacts/${contactId}`, // DELETE
  },
  SOURCES: "/lead-sources",
  SOURCE: (id) => `/lead-sources/${id}`,
  SOURCES_REORDER: "/lead-sources/reorder",
  CUSTOM_FIELDS: "/leads/custom-fields",
  CUSTOM_FIELD: (id) => `/leads/custom-fields/${id}`,
  CUSTOM_FIELDS_REORDER: "/leads/custom-fields/reorder",
  CUSTOM_FIELD_ATTACHMENT_SIGNED_URL: (leadId) =>
    `/leads/${leadId}/custom-fields/attachments/url`,
};

const SEARCH = {
  GLOBAL: "/search/global",
};

const LEAD_GENERATOR = {
  TRACK_USAGE: "/lead-generator/usage",
  HISTORY: "/lead-generator/history",
  IMPORT_TO_FUNNEL: "/lead-generator/import-to-funnel",
  IMPORT_TO_FUNNEL_JOB_STATUS: (jobId) =>
    `/lead-generator/import-to-funnel/jobs/${jobId}`,
};

const GOALS = {
  LIST: "/goals",
  CREATE: "/goals",
  UPDATE: (id) => `/goals/${id}`,
  DELETE: (id) => `/goals/${id}`,
  // Biblioteca de indicadores (categorias + metadados de cada métrica).
  METRICS: "/goals/metrics",
  // Árvore de desdobramento (Empresa → Setor → Time → Pessoa).
  TREE: "/goals/tree",
  // Ranking de performance das pessoas (score derivado das metas).
  RANKING: "/goals/ranking",
  // Proposta de divisão do alvo e criação das metas filhas.
  DISTRIBUTION: (id) => `/goals/${id}/distribution`,
  BREAKDOWN: (id) => `/goals/${id}/breakdown`,
};

// RBAC — papéis e permissões da empresa.
const ROLES = {
  // O que o usuário LOGADO pode fazer. Alimenta o menu e os botões; não exige
  // permissão nenhuma além de estar autenticado.
  MY_ACCESS: "/me/access",
  CATALOG: "/roles/catalog",
  LIST: "/roles",
  CREATE: "/roles",
  GET: (id) => `/roles/${id}`,
  UPDATE: (id) => `/roles/${id}`,
  DELETE: (id) => `/roles/${id}`,
  ASSIGNMENTS: "/roles/assignments",
  ASSIGN: (userId) => `/users/${userId}/role`,
};

// Área do desenvolvedor: chaves da API pública e webhooks de saída.
const DEVELOPER = {
  META: "/developer/meta",
  API_KEYS: "/developer/api-keys",
  API_KEY_REVOKE: (id) => `/developer/api-keys/${id}/revoke`,
  API_KEY: (id) => `/developer/api-keys/${id}`,
  WEBHOOKS: "/developer/webhooks",
  WEBHOOK: (id) => `/developer/webhooks/${id}`,
  WEBHOOK_TEST: (id) => `/developer/webhooks/${id}/test`,
  WEBHOOK_DELIVERIES: (id) => `/developer/webhooks/${id}/deliveries`,
  DELIVERIES: "/developer/deliveries",
  REDELIVER: (id) => `/developer/deliveries/${id}/redeliver`,
};

// Lead scoring.
const LEAD_SCORING = {
  META: "/lead-scoring/meta",
  RULES: "/lead-scoring/rules",
  RULE: (id) => `/lead-scoring/rules/${id}`,
  SEED: "/lead-scoring/seed",
  RECALCULATE: "/lead-scoring/recalculate",
  LEAD: (leadId) => `/lead-scoring/leads/${leadId}`,
  LEAD_RECALCULATE: (leadId) => `/lead-scoring/leads/${leadId}/recalculate`,
};

// Cadências de follow-up.
const CADENCES = {
  META: "/cadences/meta",
  LIST: "/cadences",
  CREATE: "/cadences",
  GET: (id) => `/cadences/${id}`,
  UPDATE: (id) => `/cadences/${id}`,
  DELETE: (id) => `/cadences/${id}`,
  STEPS: (id) => `/cadences/${id}/steps`,
  ENROLL: (id) => `/cadences/${id}/enroll`,
  ENROLLMENTS: "/cadence-enrollments",
  ENROLLMENT: (id) => `/cadence-enrollments/${id}`,
  ENROLLMENT_STATUS: (id) => `/cadence-enrollments/${id}/status`,
  BY_LEAD: (leadId) => `/leads/${leadId}/cadences`,
};

// Modelos de funil por vertical.
const FUNNEL_TEMPLATES = {
  LIST: "/funnel-templates",
  PREVIEW: (key) => `/funnel-templates/${key}`,
  APPLY: (key) => `/funnel-templates/${key}/apply`,
};

const CRM_REPORTS = {
  GET_OVERVIEW: "/reports/overview",
  GET_OVERVIEW_DEALS: "/reports/overview/deals",
  GET_OVERVIEW_ACTIVITIES: "/reports/overview/activities",
  GET_OVERVIEW_CUSTOM_WIDGETS: "/reports/overview/custom-widgets",
  GET_METRICS_CATALOG: "/reports/metrics/catalog",
  POST_METRICS_QUERY: "/reports/metrics/query",
  POST_METRICS_WIDGETS: "/reports/metrics/widgets",
  POST_METRICS_DETAIL: "/reports/metrics/detail",
};

const REPORT_TEMPLATES = {
  LIST:   "/report-templates",
  CREATE: "/report-templates",
  UPDATE: (id) => `/report-templates/${id}`,
  DELETE: (id) => `/report-templates/${id}`,
  // Registra uma métrica nova no cardVisibility de todos os relatórios do usuário
  REGISTER_METRIC: "/report-templates/register-metric",
};

const STAGE_FORMS = {
  // ---- CRUD de formulários por etapa ----
  LIST: "/stage-forms", // GET ?stageId=&isActive=true|false
  LATEST: "/stage-forms/latest", // GET ?stageId=
  CREATE: "/stage-forms", // POST { stageId, name, schema, version?, isActive? }
  UPDATE: (id) => `/stage-forms/${id}`, // PUT  { name?, schema?, version?, isActive? }
  DELETE: (id) => `/stage-forms/${id}`, // DELETE

  // ---- Respostas por card (histórico/validação) ----
  CARD: {
    LIST_RESPONSES: (cardId) => `/cards/${cardId}/forms`, // GET
    LAST_RESPONSE: (cardId, stageFormId) =>
      `/cards/${cardId}/forms/${stageFormId}/last`, // GET
    SAVE_RESPONSE: (cardId) => `/cards/${cardId}/forms`, // POST { stageFormId, answers, filledByUserId? }
    VALIDATE_ENTER: (cardId) => `/cards/${cardId}/forms/validate-enter`, // POST { toStageId }
    SAVE_AND_VALIDATE: (cardId) => `/cards/${cardId}/forms/save-and-validate`, // POST { toStageId, stageFormId?, answers?, filledByUserId? }
  },
};

const ACTIVITIES = {
  // Feed global do tenant (usa req.user.companyId no backend)
  // GET /api/activities
  // Query params opcionais: ?q=&actions=CARD_CREATED,CARD_UPDATED&targetType=&targetId=&actorUserId=&dateFrom=&dateTo=&page=&itemsPerPage=
  LIST_GLOBAL: "/activities",

  // Timeline por Card
  // GET /api/cards/:cardId/activities
  // Ex.: ACTIVITIES.LIST_BY_CARD(123) -> "/cards/123/activities"
  // Aceita os mesmos query params do global.
  LIST_BY_CARD: (cardId) => `/cards/${cardId}/activities`,
};

const ONBOARDING = {
  GET: "/onboarding/status",
  POST: "/onboarding",
  SKIP: "/onboarding/skip",
};

const NOTIFICATIONS = {
  LIST: () => `/notifications`,

  // Marca UMA notificação como lida
  // Ex.: PATCH NOTIFICATIONS.MARK_ONE_READ(id)
  MARK_ONE_READ: (id) => `/notifications/${id}/read`,

  // Exclui UMA notificação
  // Ex.: DELETE NOTIFICATIONS.DELETE_ONE(id)
  DELETE_ONE: (id) => `/notifications/${id}`,

  // Marca TODAS como lidas
  // Ex.: POST NOTIFICATIONS.MARK_ALL_READ
  MARK_ALL_READ: `/notifications/mark-all-read`,
};

const CHAT = {
  DM_ENSURE: "/chat/dm/ensure", // POST { userId }
  DM_LIST: "/chat/dm", // GET
  DM_MESSAGES: (threadId) => `/chat/dm/${threadId}/messages`, // GET
  DM_SEND: `/chat/dm/messages`,
  PRESENCE: "/chat/presence",
};

const AI = {
  INSIGHTS: "/insights", // POST { userId }
};

const CALENDAR = {
  EVENTS: "/calendar/events", // GET (list, ?dateFrom&dateTo&userId&allUsers) | POST (create)
  EVENT: (eventId) => `/calendar/events/${eventId}`, // GET | PUT | DELETE
  RESPOND: (eventId) => `/calendar/events/${eventId}/respond`, // POST { status }
};

const BOOKING = {
  // Config (autenticada)
  EVENT_TYPES: "/booking/event-types",
  EVENT_TYPE: (id) => `/booking/event-types/${id}`,
  // Público (sem login)
  PUBLIC: (slug) => `/agendar/${slug}`,
  PUBLIC_AVAILABILITY: (slug) => `/agendar/${slug}/disponibilidade`,
  MANAGE: (token) => `/agendamento/${token}`,
  CANCEL: (token) => `/agendamento/${token}/cancelar`,
  RESCHEDULE: (token) => `/agendamento/${token}/remarcar`,
};

const CUSTOM_FIELDS = {
  LIST: (funnelId) => `/crm/funnels/${funnelId}/custom-fields`,
  UPSERT: (funnelId) => `/crm/funnels/${funnelId}/custom-fields`,
  DELETE: (funnelId, fieldId) =>
    `/crm/funnels/${funnelId}/custom-fields/${fieldId}`,
};

let SOCKET_URL = "";
if (process.env.NODE_ENV === "development") {
  SOCKET_URL = "http://localhost:3000";
} else if (process.env.NODE_ENV === "production") {
  SOCKET_URL = "https://app.relinqsales.com.br";
}

export {
  API,
  DASHBOARD,
  LOGIN,
  PASSWORD_RECOVERY,
  LOAN,
  BLACKLIST,
  CATEGORIES,
  COMPANY,
  USERS,
  ADMIN,
  CHARGES,
  QUERIES,
  QUERIES_VEICULAR,
  AUDITS,
  AVATAR,
  PAYMENTS,
  REPORTS,
  SURVEYS,
  CRM,
  BUDGETS,
  PRODUCTS,
  PRODUCT_UNITS,
  TAGS,
  TEAMS,
  LEADS,
  INTEGRATIONS,
  EMAILS,
  EMAIL_TEMPLATES,
  EMAIL_SIGNATURES,
  VOIP,
  WHATSAPP,
  LEAD_GENERATOR,
  SEARCH,
  GOALS,
  STAGE_FORMS,
  ACTIVITIES,
  BASE_URL,
  ONBOARDING,
  NOTIFICATIONS,
  CHAT,
  AI,
  CALENDAR,
  BOOKING,
  CUSTOM_FIELDS,
  CRM_REPORTS,
  REPORT_TEMPLATES,
  SOCKET_URL,
  FILIAL,
  ROLES,
  DEVELOPER,
  LEAD_SCORING,
  CADENCES,
  FUNNEL_TEMPLATES,
  IMPORT_FILES,
};
